import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const Breadcrumb = ({ items }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://ntxpipefence.com/" },
      ...items.map((item, i) => ({
        "@type": "ListItem",
        "position": i + 2,
        "name": item.label,
        ...(item.href ? { "item": `https://ntxpipefence.com${item.href}` } : {})
      }))
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <nav aria-label="Breadcrumb" className="py-3 px-4 sm:px-6 lg:px-8 bg-zinc-950 border-b border-zinc-800/50" data-testid="breadcrumb-nav">
        <div className="max-w-7xl mx-auto">
          <ol className="flex items-center flex-wrap gap-1 text-sm">
            <li>
              <Link to="/" className="text-zinc-500 hover:text-red-500 transition-colors flex items-center gap-1">
                <Home size={13} />
                <span>Home</span>
              </Link>
            </li>
            {items.map((item, i) => (
              <li key={item.label} className="flex items-center gap-1">
                <ChevronRight size={12} className="text-zinc-700" />
                {item.href && i < items.length - 1 ? (
                  <Link to={item.href} className="text-zinc-500 hover:text-red-500 transition-colors">{item.label}</Link>
                ) : (
                  <span className="text-zinc-300 font-medium">{item.label}</span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
};
